// extracted by mini-css-extract-plugin
export default {"text":"XMtZV"};